import styled, { css } from 'styled-components'

import { breakpoint } from '@sketch/global-styles'

import { TableComponents } from '@sketch/components'

export const TableWrapper = styled.div`
  margin-top: 24px;

  ${TableComponents.Table} {
    width: 100%;

    ${TableComponents.TableRow} {
      cursor: pointer;
    }

    ${/* sc-selector */ TableComponents.TableCell}:last-child {
      text-align: right;

      ${breakpoint('base', 'sm')`
        text-align: left;
      `}
    }
  }
`

export const NameAndExpiryContainer = styled.div`
  display: flex;
  flex-direction: column;

  overflow: hidden;
  flex: 1;
`

export const TokenName = styled.span<{ expired: boolean }>(
  ({ expired, theme }) => css`
    font-size: ${theme.fontSizes.E};
    font-weight: ${theme.fontWeights.medium};
    color: ${expired
      ? theme.colors.foreground.secondary.D
      : theme.colors.foreground.secondary.A};
  `
)

export const TokenExpiry = styled.span(
  ({ theme }) => css`
    font-size: ${theme.fontSizes.D};
    color: ${theme.colors.foreground.secondary.D};
  `
)
